module.exports = __webpack_public_path__ + "media/images/icons/filled/customer-service-30af1d8a8e1d39a3dcbe1cb2619db9a1.svg";